import { ALERT_GREEN, ALERT_RED, ALERT_YELLOW } from '../marketplace-custom-config';

export const checkPasswordStrength = (intl, value, checkRefValues = []) => {
  const minLength = 12; // Minimum length of 8 characters
  const hasUppercase = /[A-Z]/; // Contains at least one uppercase letter
  const hasLowercase = /[a-z]/; // Contains at least one lowercase letter
  const hasNumber = /[0-9]/; // Contains at least one number
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/; // Contains at least one special character
  let score = 0;
  if (value.length >= minLength) score++; //1
  if (hasUppercase.test(value)) score++; //2
  if (hasLowercase.test(value)) score++; //3
  if (hasNumber.test(value)) score++; //4
  if (hasSpecialChar.test(value)) score++; //5

  const lwrCaseValue = value.toLowerCase();
  const filteredCheckRefValues = checkRefValues.reduce((pre, value) => {
    if (typeof value === 'string' && !!value) {
      let filteredValue = value
        .replace(/@.+$/g, '')
        .replace(/\.+/g, '.')
        .replace(/(^\.|\.$)/g, '');
      pre.push(...filteredValue.split('.'));
    }
    return pre;
  }, []);

  for (let refValue of filteredCheckRefValues) {
    if (lwrCaseValue.includes(refValue.toLowerCase())) {
      score--;
    }
  }

  if (score <= 2) {
    return {
      alertType: ALERT_RED,
      message: intl.formatMessage({ id: 'FieldPassword.weakPassword' }),
    };
  } else if (score > 2 && score <= 4) {
    return {
      alertType: ALERT_YELLOW,
      message: intl.formatMessage({ id: 'FieldPassword.mediumPassword' }),
    };
  }
  return {
    alertType: ALERT_GREEN,
    message: intl.formatMessage({ id: 'FieldPassword.strongPassword' }),
  };
};
